import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import ProductService from "../../shared/service/ProductService";
import {InputNumber} from "primereact/inputnumber";
import '../../shared/styles/SettingsPage.css';


const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    price: null,
    price2: null,
    price3: null,
    price4: ''
};

export default class ProductPriceSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
        }
        this.productService = new ProductService();
    }

    componentDidMount() {

    }

    clearData = () => {
        this.setState({
            product: Object.assign({}, defaultProduct),
        });
    }

    setData = (data) => {
        this.setState({
            product: Object.assign({}, data),
        });
    }

    render() {
        return (
            <div className="settings-page settings-page--dialog">
                <h2 className="settings-page__section-title">Update Price</h2>

                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__filter-row settings-page__filter-row--cols-3 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="price-save-barcode">
                                    <Translate contentKey="producttradingName">Barcode</Translate>
                                </Label>
                                <AvField
                                    id="price-save-barcode"
                                    type="number"
                                    className="form-control"
                                    name="barcode"
                                    disabled={true}
                                    max="99999999999999"
                                    value={this.state.product.barcode}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="price-save-name">
                                    <Translate contentKey="producttradingName">Name</Translate>
                                </Label>
                                <AvField
                                    id="price-save-name"
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    disabled={true}
                                    value={this.state.product.name}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="price-save-till">
                                    <Translate contentKey="producttradingName">Till Price</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <InputNumber
                                    inputId="price-save-till"
                                    name="price"
                                    disabled={false}
                                    value={this.state.product.price}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    currency="GBP"
                                    locale="en-US"
                                    className="table-responsive"
                                />
                            </AvGroup>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__filter-row--cols-3 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="price-save-2">
                                    <Translate contentKey="producttradingName">Price 2</Translate>
                                </Label>
                                <InputNumber
                                    inputId="price-save-2"
                                    name="price2"
                                    disabled={false}
                                    value={this.state.product.price2}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    currency="GBP"
                                    locale="en-US"
                                    className="table-responsive"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="price-save-3">
                                    <Translate contentKey="producttradingName">Price 3</Translate>
                                </Label>
                                <InputNumber
                                    inputId="price-save-3"
                                    name="price3"
                                    disabled={false}
                                    value={this.state.product.price3}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    currency="GBP"
                                    locale="en-US"
                                    className="table-responsive"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="price-save-4">
                                    <Translate contentKey="producttradingName">Price 4</Translate>
                                </Label>
                                <InputNumber
                                    inputId="price-save-4"
                                    name="price4"
                                    disabled={false}
                                    value={this.state.product.price4}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    currency="GBP"
                                    locale="en-US"
                                    className="table-responsive"
                                />
                            </AvGroup>
                        </div>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.updateProduct();
                        }}>
                            <Translate contentKey="entity.action.add">Save Price</Translate>
                        </Button>
                    }
                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close" onClick={() => {
                        this.props.closeDisplayDialog();
                    }}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    updateProduct = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.update(this.state.product)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            product: response,
                        });
                        this.props.refreshDataTable();
                    }
                });
        }
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let product = this.state.product;
        product[e.target.name] = value;
        this.setState({product: product});
    }
}

ProductPriceSave.propTypes = {
    order: PropTypes.object
};
